"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[5996],{

/***/ 63034:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: () => (/* binding */ Column)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Column = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("div", (props)=>({
        display: "flex",
        flexDirection: "column",
        justifyContent: props.$align,
        gap: props.$gap,
        "data-testid": props.dataTestId
    }));


/***/ }),

/***/ 77301:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ PlainButton)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45199);



/**
 * A plain button component that doesn't apply any styling to the contents
 *
 * Useful for making clickable elements inside other things. Try to use this instead of a `div` or `Row` with an `onClick` :)
 */ const PlainButton = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("button", ({ $theme, $row, $selected, $style })=>{
    return lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()({
        fontFamily: "inherit",
        lineHeight: "inherit",
        fontWeight: "inherit",
        fontSize: "inherit",
        textDecoration: "underline",
        display: $row ? "flex" : "initial",
        alignItems: "center",
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandPadding */ .ft)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandMargin */ .ds)(0),
        ...(0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .expandBorderWidth */ .wW)("0px"),
        backgroundColor: $selected ? $theme.colors.primary200 : "unset",
        width: "min-content",
        whiteSpace: "nowrap",
        textUnderlinePosition: "under",
        color: "unset",
        ":hover": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset",
            color: $theme.colors.contentTertiary,
            cursor: "pointer"
        },
        ":active": {
            backgroundColor: $selected ? $theme.colors.primary200 : "unset"
        },
        ":focus-visible": {
            outline: `auto 1px ${$theme.colors.borderFocus}`
        }
    }, $style);
});


/***/ }),

/***/ 9179:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: () => (/* binding */ AccordionExpandIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74995);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73352);
/* harmony import */ var lodash_omit__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_omit__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30242);




const AccordionExpandIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_2__/* .useStyletron */ .hQ)();
    let rotation = 0;
    if (props.direction == "down") {
        rotation = 90;
    } else if (props.direction == "left") {
        rotation = 180;
    } else if (props.direction == "up") {
        rotation = -90;
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_3__/* .Svg */ .n, {
        viewBox: "0 0 30 30",
        ...lodash_omit__WEBPACK_IMPORTED_MODULE_0___default()(props, "direction")
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
        d: "M20.625 15.0001C20.625 15.1974 20.5494 15.3948 20.3991 15.5451L12.6908 23.2534C12.4704 23.4738 12.1389 23.5401 11.8506 23.4207C11.5623 23.3019 11.375 23.0198 11.375 22.7084V7.29179C11.375 6.98037 11.5623 6.69825 11.8506 6.57954C12.1389 6.46006 12.4704 6.52635 12.6908 6.74681L20.3991 14.4551C20.5494 14.6054 20.625 14.8028 20.625 15.0001Z",
        fill: props.color || $theme.colors.contentSecondary,
        transform: `rotate(${rotation} 15 15)`
    }));
};


/***/ }),

/***/ 94497:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: () => (/* binding */ CircleCheckIcon)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10334);
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);



const CircleCheckIcon = (props)=>{
    const [_css, $theme] = (0,baseui__WEBPACK_IMPORTED_MODULE_1__/* .useStyletron */ .hQ)();
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_2__/* .Svg */ .n, {
        viewBox: "0 0 12 12",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
        cx: "6",
        cy: "6",
        r: "6",
        fill: props.backgroundColor ?? "white"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M6 1.83333C8.2975 1.83333 10.1667 3.7025 10.1667 6C10.1667 8.2975 8.2975 10.1667 6 10.1667C3.7025 10.1667 1.83333 8.2975 1.83333 6C1.83333 3.7025 3.7025 1.83333 6 1.83333ZM6 1C3.23875 1 1 3.23875 1 6C1 8.76125 3.23875 11 6 11C8.76125 11 11 8.76125 11 6C11 3.23875 8.76125 1 6 1ZM7.83042 4.125L5.47917 6.535L4.3775 5.49083L3.60417 6.265L5.47917 8.08333L8.60417 4.89875L7.83042 4.125Z",
        fill: props.color ?? $theme.colors.positive
    }));
};


/***/ }),

/***/ 69525:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   T: () => (/* binding */ CloseIcon)
/* harmony export */ });
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


const CloseIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.14478 3.17316C2.18007 3.34135 2.26456 3.49524 2.3875 3.61529L6.77382 8.00162L2.38794 12.3875C2.3055 12.4671 2.23964 12.5622 2.19418 12.6673C2.14843 12.7732 2.12426 12.8871 2.12309 13.0024C2.12192 13.1177 2.14376 13.2321 2.18735 13.3388C2.23093 13.4456 2.29537 13.5426 2.37691 13.6241C2.45844 13.7056 2.55542 13.7701 2.66217 13.8136C2.76893 13.8572 2.8833 13.8791 2.9986 13.8779C3.1139 13.8767 3.22781 13.8526 3.33365 13.8068C3.43883 13.7614 3.53395 13.6955 3.6135 13.613L7.99937 9.22717L12.3853 13.613C12.4648 13.6955 12.5599 13.7614 12.6651 13.8068C12.7709 13.8526 12.8848 13.8767 13.0001 13.8779C13.1155 13.8791 13.2298 13.8572 13.3366 13.8136C13.4433 13.7701 13.5403 13.7056 13.6218 13.6241C13.7034 13.5426 13.7678 13.4456 13.8114 13.3388C13.855 13.2321 13.8768 13.1177 13.8757 13.0024C13.8745 12.8871 13.8503 12.7732 13.8046 12.6673C13.7591 12.5622 13.6932 12.4671 13.6108 12.3875L9.22492 8.00162L13.6108 3.61576C13.736 3.49505 13.822 3.33945 13.8576 3.16917C13.8934 2.99815 13.8767 2.82032 13.8096 2.65899C13.7425 2.49766 13.6282 2.36037 13.4818 2.26512C13.3353 2.16987 13.1635 2.12111 12.9888 2.12524C12.7605 2.13063 12.5436 2.22588 12.3852 2.39025L7.99937 6.77607L3.61306 2.38975C3.5324 2.30713 3.43605 2.24144 3.32965 2.19657C3.2228 2.1515 3.10793 2.12834 2.99196 2.12844C2.81963 2.12866 2.65127 2.18024 2.5084 2.2766C2.36553 2.37296 2.25462 2.50972 2.18985 2.66942C2.12508 2.82912 2.10939 3.0045 2.14478 3.17316Z"
    }));


/***/ }),

/***/ 12586:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: () => (/* binding */ ExternalLinkIcon)
/* harmony export */ });
/* unused harmony export ExternalLinkIconBox */
/* harmony import */ var baseui_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74995);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);


// Arrow pointing through the top right corner of a square outline
const ExternalLinkIcon = (props)=>/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(baseui_icon__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .n, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M13.653 1.66042C13.6284 1.66123 13.6038 1.66341 13.5794 1.66693H9.33268C9.24434 1.66568 9.15663 1.68201 9.07465 1.71495C8.99267 1.74789 8.91806 1.7968 8.85515 1.85883C8.79223 1.92086 8.74228 1.99477 8.70818 2.07628C8.67408 2.15778 8.65652 2.24525 8.65652 2.3336C8.65652 2.42195 8.67408 2.50942 8.70818 2.59092C8.74228 2.67243 8.79223 2.74634 8.85515 2.80837C8.91806 2.8704 8.99267 2.91931 9.07465 2.95225C9.15663 2.9852 9.24434 3.00152 9.33268 3.00027H12.0566L7.528 7.52891C7.46401 7.59034 7.41293 7.66392 7.37774 7.74534C7.34255 7.82676 7.32396 7.91438 7.32305 8.00308C7.32215 8.09177 7.33896 8.17975 7.37248 8.26187C7.40601 8.34399 7.45558 8.4186 7.5183 8.48131C7.58102 8.54403 7.65562 8.59361 7.73774 8.62713C7.81986 8.66066 7.90785 8.67746 7.99654 8.67656C8.08523 8.67566 8.17286 8.65707 8.25427 8.62188C8.33569 8.58669 8.40927 8.5356 8.4707 8.47162L12.9993 3.94298V6.66693C12.9981 6.75528 13.0144 6.84298 13.0474 6.92496C13.0803 7.00694 13.1292 7.08156 13.1912 7.14447C13.2533 7.20738 13.3272 7.25734 13.4087 7.29144C13.4902 7.32554 13.5777 7.3431 13.666 7.3431C13.7544 7.3431 13.8418 7.32554 13.9233 7.29144C14.0048 7.25734 14.0788 7.20738 14.1408 7.14447C14.2028 7.08156 14.2517 7.00694 14.2847 6.92496C14.3176 6.84298 14.3339 6.75528 14.3327 6.66693V2.41563C14.3455 2.31985 14.3374 2.22241 14.3089 2.13007C14.2804 2.03774 14.2321 1.9527 14.1675 1.88087C14.1028 1.80903 14.0233 1.75211 13.9345 1.71405C13.8456 1.67598 13.7496 1.65769 13.653 1.66042ZM4.16602 2.66693C2.79358 2.66693 1.66602 3.7945 1.66602 5.16693V11.8336C1.66602 13.206 2.79358 14.3336 4.16602 14.3336H10.8327C12.2051 14.3336 13.3327 13.206 13.3327 11.8336V8.66693C13.3339 8.57859 13.3176 8.49088 13.2847 8.40891C13.2517 8.32693 13.2028 8.25231 13.1408 8.1894C13.0788 8.12649 13.0048 8.07653 12.9233 8.04243C12.8418 8.00833 12.7544 7.99077 12.666 7.99077C12.5777 7.99077 12.4902 8.00833 12.4087 8.04243C12.3272 8.07653 12.2533 8.12649 12.1912 8.1894C12.1292 8.25231 12.0803 8.32693 12.0474 8.40891C12.0144 8.49088 11.9981 8.57859 11.9993 8.66693V11.8336C11.9993 12.4825 11.4816 13.0003 10.8327 13.0003H4.16602C3.51712 13.0003 2.99935 12.4825 2.99935 11.8336V5.16693C2.99935 4.51804 3.51712 4.00027 4.16602 4.00027H7.33268C7.42102 4.00152 7.50873 3.9852 7.59071 3.95225C7.67269 3.91931 7.7473 3.8704 7.81022 3.80837C7.87313 3.74634 7.92309 3.67243 7.95719 3.59092C7.99128 3.50942 8.00884 3.42195 8.00884 3.3336C8.00884 3.24525 7.99128 3.15778 7.95719 3.07628C7.92309 2.99477 7.87313 2.92086 7.81022 2.85883C7.7473 2.7968 7.67269 2.74789 7.59071 2.71495C7.50873 2.68201 7.42102 2.66568 7.33268 2.66693H4.16602Z"
    }));
// Solid colored box with an internal arrow pointing to top right corner
const ExternalLinkIconBox = (props)=>/*#__PURE__*/ React.createElement(StyledSvg, {
        viewBox: "0 0 16 16",
        ...props
    }, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12.1667 2H3.83333C2.82233 2 2 2.82267 2 3.83333V12.1667C2 13.1773 2.82233 14 3.83333 14H12.1667C13.1777 14 14 13.1773 14 12.1667V3.83333C14 2.82267 13.1777 2 12.1667 2ZM12 8.16667C12 8.44267 11.7763 8.66667 11.5 8.66667C11.2237 8.66667 11 8.44267 11 8.16667V5.707L5.85367 10.8537C5.756 10.9513 5.628 11 5.5 11C5.372 11 5.244 10.9513 5.14633 10.8537C4.951 10.6583 4.951 10.342 5.14633 10.1467L10.293 5H7.83333C7.557 5 7.33333 4.776 7.33333 4.5C7.33333 4.224 7.557 4 7.83333 4H11.5C11.7763 4 12 4.224 12 4.5V8.16667Z"
    })));


/***/ }),

/***/ 1462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  M: () => (/* binding */ GadgetLogoMark),
  u: () => (/* binding */ GadgetLogoType)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logomark.svg
/* harmony default export */ const logomark = (__webpack_require__.p + "1b5b906861f70ec70ea51c35c1e023be.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/assets/logotype.svg
/* harmony default export */ const logotype = (__webpack_require__.p + "13513703c5b41ce947547e20671b9409.svg");
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx



const GadgetLogoType = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logotype
    });
};
const GadgetLogoMark = (props)=>{
    return /*#__PURE__*/ react.createElement("img", {
        ...props,
        src: logomark
    });
};


/***/ }),

/***/ 71910:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D: () => (/* binding */ Title)
/* harmony export */ });
/* harmony import */ var baseui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10334);

const Title = (0,baseui__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zo)("h1", ({ $theme })=>({
        ...$theme.typography.title,
        color: $theme.colors.contentPrimary
    }));


/***/ }),

/***/ 23588:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: () => (/* binding */ PaymentRequiredCard)
/* harmony export */ });
/* harmony import */ var _gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45916);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);
/* harmony import */ var _editor_EmptyStateCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90290);



const PaymentRequiredCard = ({ email })=>{
    const rootURL =  false ? 0 : "https://app.gadget.dev";
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_editor_EmptyStateCard__WEBPACK_IMPORTED_MODULE_1__/* .EmptyStateCard */ .w, {
        title: "Sorry, your application is unavailable.",
        message: "Your application will be unavailable until you upgrade to a paid plan.",
        actions: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_gadgetinc_widgets__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zx, {
            $as: "a",
            href: `${rootURL}/auth/billing#plans`,
            target: "_blank"
        }, "Upgrade plan")
    });
};


/***/ }),

/***/ 45695:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ../../node_modules/.pnpm/@sentry+react@7.15.0_react@0.0.0-experimental-4ead6b530/node_modules/@sentry/react/esm/sdk.js
var sdk = __webpack_require__(91512);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/react-dom/index.js
var react_dom = __webpack_require__(5556);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/modal/Modal.tsx
var Modal = __webpack_require__(6710);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(45199);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Button.tsx
var Button = __webpack_require__(45916);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Link.tsx
var Link = __webpack_require__(77780);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/EditTheme.ts
var EditTheme = __webpack_require__(68936);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/base-provider.js
var base_provider = __webpack_require__(57040);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/heading/heading-level.js
var heading_level = __webpack_require__(12715);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/typography/index.js
var typography = __webpack_require__(61022);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styletron-react@6.0.2_react@0.0.0-experimental-4ead6b530/node_modules/styletron-react/dist/browser.es5.es.js
var browser_es5_es = __webpack_require__(81262);
// EXTERNAL MODULE: ./src/lib/styletronEngine.tsx
var styletronEngine = __webpack_require__(40237);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx@6.5.0/node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(77662);
;// CONCATENATED MODULE: ./src/components/edit/editor/panel/hooks.ts


let id = 0;
const semaphores = mobx_esm.observable.map();
const semaphoreTaken = (key)=>{
    return !!semaphores.get(key);
};
const useSemaphore = (key)=>{
    const me = react.useMemo(()=>id++, []);
    // we use a react state here so that we can set something and trigger a rerender
    const [hasSemaphore, setHasSemaphore] = react.useState(false);
    react.useEffect(()=>{
        if (semaphores.get(key) == undefined) {
            semaphores.set(key, me);
        }
        if (semaphores.get(key) == me) {
            setHasSemaphore(true);
        }
        return ()=>{
            if (semaphores.get(key) == me) {
                semaphores.delete(key);
            }
        };
    }, [
        key,
        me,
        setHasSemaphore
    ]);
    return hasSemaphore;
};

// EXTERNAL MODULE: ./src/components/chrome/DebugDisplay.tsx
var DebugDisplay = __webpack_require__(3385);
;// CONCATENATED MODULE: ./src/components/chrome/UserFacingErrorHandler.tsx
/* eslint-disable @typescript-eslint/no-misused-promises */ 










const ErrorUISemaphoreKey = "user-facing-error";
const ShowDeveloperErrorInfoKey = "show-dev-errors";
const ErrorModal = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const hasSemaphore = useSemaphore(ErrorUISemaphoreKey); // only let one panel per node open at once
    const [isOpen, setIsOpen] = (0,react.useState)(true);
    const [isLoading, setIsLoading] = (0,react.useState)(false);
    const [isShowingErrorInfo, setShowErrorInfo] = (0,react.useState)( false || !!localStorage.getItem(ShowDeveloperErrorInfoKey));
    const close = ()=>setIsOpen(false);
    const refresh = ()=>{
        setIsLoading(true);
        window.location.reload();
    };
    const showErrorInfo = ()=>{
        setShowErrorInfo(true);
        localStorage.setItem(ShowDeveloperErrorInfoKey, "yes");
    };
    return /*#__PURE__*/ react.createElement(Modal/* Modal */.u_, {
        onClose: close,
        isOpen: isOpen && hasSemaphore,
        autoFocus: false,
        overrides: {
            Dialog: {
                style: {
                    width: "80vw",
                    height: "80vh",
                    display: "flex",
                    flexDirection: "column",
                    ...(0,utils/* expandBaseWebBorder */.yc)({
                        ...$theme.borders.border300,
                        borderColor: $theme.colors.negative300
                    })
                }
            }
        },
        title: /*#__PURE__*/ react.createElement("div", {
            style: {
                color: $theme.colors.negative500
            }
        }, "Oops, there's been an error."),
        footer: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(Button/* Button */.zx, {
            kind: "tertiary",
            onClick: close
        }, "Close"), /*#__PURE__*/ react.createElement(Button/* Button */.zx, {
            isLoading: isLoading,
            onClick: refresh
        }, "Refresh"))
    }, /*#__PURE__*/ react.createElement(heading_level/* default */.ZP, null, "This application encountered an unexpected issue. The developer has been alerted. For now, you can close this dialog, or", " ", /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: "#",
        onClick: refresh
    }, "refresh"), " ", "the page and try again.", /*#__PURE__*/ react.createElement("div", {
        className: css({
            marginTop: $theme.sizing.scale400
        })
    }, !isShowingErrorInfo && /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: "#",
        onClick: showErrorInfo
    }, "Developers: Show Error Info"), isShowingErrorInfo && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(typography/* HeadingSmall */.Jf, null, "Error Info"), /*#__PURE__*/ react.createElement("br", null), /*#__PURE__*/ react.createElement(typography/* HeadingXSmall */.fH, null, "JS Error"), /*#__PURE__*/ react.createElement(DebugDisplay/* ErrorDisplay */.X, {
        error: props.error
    }), /*#__PURE__*/ react.createElement("br", null)))));
};
const installErrorHandler = ()=>{
    const showError = (error)=>{
        if (semaphoreTaken(ErrorUISemaphoreKey)) return;
        const root = document.createElement("div");
        document.body.appendChild(root);
        react_dom.unstable_createRoot(root).render(/*#__PURE__*/ react.createElement(react.StrictMode, null, /*#__PURE__*/ react.createElement(browser_es5_es/* Provider */.zt, {
            value: styletronEngine/* styletronEngine */.F,
            debug: styletronEngine/* styletronDebug */.A
        }, /*#__PURE__*/ react.createElement(base_provider/* default */.Z, {
            theme: EditTheme/* EditLightTheme */.PW,
            overrides: {
                AppContainer: {
                    style: {
                        height: "100%"
                    }
                }
            }
        }, /*#__PURE__*/ react.createElement(ErrorModal, {
            error: error
        })))));
    };
    try {
        Error.stackTraceLimit = 50;
    } catch (e) {
    // Not all browsers support this so we don't care if it errors
    }
    window.addEventListener("error", (event)=>{
        showError(event.error);
    });
    window.addEventListener("unhandledrejection", (event)=>{
        let error;
        if (event == null || event.reason == null) {
            error = new Error("Unknown");
        } else {
            if (event.reason instanceof Error) {
                error = event.reason;
            } else {
                // A non-error was rejected, we don't have a trace :(
                // Look in your browser's devtools for more information
                error = new Error(event.reason);
            }
        }
        showError(error);
    });
};

// EXTERNAL MODULE: ./src/lib/flags.ts
var flags = __webpack_require__(20280);
// EXTERNAL MODULE: ./src/lib/global.css
var global = __webpack_require__(62790);
// EXTERNAL MODULE: ./src/components/edit/shared/PaymentRequiredCard.tsx
var PaymentRequiredCard = __webpack_require__(23588);
// EXTERNAL MODULE: ./src/components/chrome/NotFound.tsx + 3 modules
var NotFound = __webpack_require__(65383);
;// CONCATENATED MODULE: ./src/components/chrome/ApplicationUnavailable.tsx





const ApplicationUnavailable = ({ code, userEmail })=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const paymentRequired = !!userEmail && code === "402";
    return /*#__PURE__*/ react.createElement(react.Fragment, null, userEmail && /*#__PURE__*/ react.createElement(NotFound/* ErrorNavBar */.O, {
        logoOnly: true,
        user: userEmail
    }), /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            ...(0,utils/* expandPadding */.ft)($theme.sizing.scale1600),
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, paymentRequired ? /*#__PURE__*/ react.createElement(PaymentRequiredCard/* PaymentRequiredCard */.x, {
        email: userEmail
    }) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", {
        className: css({
            ...$theme.typography.MonoHeadingLarge
        })
    }, "Sorry, this application is unavailable."))));
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/icon/styled-components.js
var styled_components = __webpack_require__(74995);
;// CONCATENATED MODULE: ../@gadgetinc/widgets/src/icons/ProhibitionHorizontalIcon.tsx


function ProhibitionHorizontalIcon(props) {
    return /*#__PURE__*/ react.createElement(styled_components/* Svg */.n, {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ react.createElement("path", {
        d: "M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM8 1.6C11.52 1.6 14.4 4.48 14.4 8C14.4 11.52 11.52 14.4 8 14.4C4.48 14.4 1.6 11.52 1.6 8C1.6 4.48 4.48 1.6 8 1.6ZM3.2 7.2V8.8H12.8V7.2H3.2Z"
    }));
}

;// CONCATENATED MODULE: ./src/components/chrome/NoPermission.tsx





const NoPermission = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    // Performs a HEAD request at the current page to check if the user has permission to access the page every 5 seconds
    // If the user has permission, the page will automatically reload
    // If the user does not have permission, the page will stay as it is
    const MAX_RETRIES = 1000;
    const INTERVAL = 5000;
    const targetURL = window.location.href.split("?")[0];
    const attempts = (0,react.useRef)(0);
    (0,react.useEffect)(()=>{
        const interval = setInterval(()=>{
            if (attempts.current++ >= MAX_RETRIES || document.hidden) return;
            fetch(targetURL, {
                method: "HEAD"
            }).then((response)=>{
                if (response.ok) {
                    window.location.href = targetURL;
                }
            }).catch(()=>{
                return;
            });
        }, INTERVAL);
        return ()=>clearInterval(interval);
    }, [
        attempts,
        targetURL
    ]);
    const rootURL =  true ? "https://app.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(NotFound/* ErrorNavBar */.O, {
        logoOnly: true,
        user: props.userEmail
    }), /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexDirection: "column",
            fontFamily: $theme.typography.ParagraphLarge.fontFamily
        })
    }, /*#__PURE__*/ react.createElement("div", {
        className: css({
            fontSize: $theme.sizing.scale700,
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: $theme.sizing.scale500
        })
    }, /*#__PURE__*/ react.createElement(ProhibitionHorizontalIcon, null), props.message ?? "You don’t have permission to view this app"), /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            marginTop: $theme.sizing.scale1000,
            marginBottom: $theme.sizing.scale600,
            gap: $theme.sizing.scale500
        })
    }, /*#__PURE__*/ react.createElement(Button/* Button */.zx, {
        onClick: ()=>window.location.href = `${rootURL}/auth/logout`,
        kind: "secondary"
    }, "Logout"), /*#__PURE__*/ react.createElement(Button/* Button */.zx, {
        onClick: ()=>history.back()
    }, "Go Back"))));
};
/* harmony default export */ const chrome_NoPermission = (NoPermission);

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Column.tsx
var Column = __webpack_require__(63034);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Text.tsx
var Text = __webpack_require__(86358);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(71567);
// EXTERNAL MODULE: ./src/components/Title.tsx
var Title = __webpack_require__(71910);
;// CONCATENATED MODULE: ./src/components/chrome/StillSettingUp.tsx




const StillSettingUp = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            padding: $theme.sizing.scale1600,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement(Column/* Column */.s, {
        $gap: $theme.sizing.scale800
    }, /*#__PURE__*/ react.createElement(Title/* Title */.D, {
        $style: {
            fontSize: "32px",
            fontWeight: 700
        }
    }, "Still setting up..."), /*#__PURE__*/ react.createElement(Text/* Text */.x, null, "This app isn't available yet because it is still setting up. Please try again in a few moments."), /*#__PURE__*/ react.createElement(Row/* Row */.X, null, /*#__PURE__*/ react.createElement(Button/* Button */.zx, {
        $as: "a",
        href: `https://${props.primaryDomain}/edit`
    }, "Back to editor"))));
};

;// CONCATENATED MODULE: ./src/components/chrome/UndeployedEnvironment.tsx




const UndeployedEnvironment = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const docsURL =  true ? "https://docs.gadget.dev" : 0;
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            padding: $theme.sizing.scale1600,
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement(Column/* Column */.s, {
        $gap: $theme.sizing.scale800
    }, /*#__PURE__*/ react.createElement(Title/* Title */.D, {
        $style: {
            fontSize: "32px",
            fontWeight: 700
        }
    }, "This app hasn't been deployed to production."), /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $gap: $theme.sizing.scale600
    }, /*#__PURE__*/ react.createElement(Button/* Button */.zx, {
        $as: "a",
        href: `https://${props.primaryDomain}/edit`
    }, "Back to editor"), /*#__PURE__*/ react.createElement(Link/* Link */.r, {
        href: `${docsURL}/guides/deployment`
    }, "Learn about deploying"))));
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/CircleCheckIcon.tsx
var CircleCheckIcon = __webpack_require__(94497);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/WarningIcon.tsx
var WarningIcon = __webpack_require__(28418);
// EXTERNAL MODULE: ./src/components/chrome/CenteredSpin.tsx
var CenteredSpin = __webpack_require__(29574);
;// CONCATENATED MODULE: ./src/components/chrome/InfoPoller.tsx


const InfoPoller = ()=>{
    (0,react.useEffect)(()=>{
        setTimeout(()=>window.location.reload(), 3000);
    }, []);
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(CenteredSpin/* CenteredSpin */.V, null));
};

;// CONCATENATED MODULE: ./src/components/render/InfoPage.tsx






const InfoPage = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const iconStyles = {
        $size: 50,
        color: "black",
        backgroundColor: "transparent"
    };
    let iconComponent;
    switch(props.icon){
        case "Error":
            {
                iconComponent = /*#__PURE__*/ react.createElement(WarningIcon/* WarningIcon */.a, iconStyles);
                break;
            }
        case "Success":
            {
                iconComponent = /*#__PURE__*/ react.createElement(CircleCheckIcon/* CircleCheckIcon */.o, iconStyles);
                break;
            }
    }
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            ...(0,utils/* expandPadding */.ft)($theme.sizing.scale1600),
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            gap: $theme.sizing.scale800
        })
    }, /*#__PURE__*/ react.createElement("div", null, iconComponent), props.message.split("\n").map((text, index)=>/*#__PURE__*/ react.createElement("div", {
            key: index,
            className: css({
                ...$theme.typography.MonoHeadingLarge
            }),
            dangerouslySetInnerHTML: {
                __html: text
            }
        })), props.userEmail && /*#__PURE__*/ react.createElement("a", {
        href: props.logsLink,
        className: css({
            ...$theme.typography.MonoHeadingLarge
        })
    }, props.logsLink), props.poll && /*#__PURE__*/ react.createElement(InfoPoller, null));
};

;// CONCATENATED MODULE: ./src/components/render/InfoApp.tsx














const InfoAppContainer = ()=>{
    const { icon, message, logsLink, code, ggtCode, poll, primaryDomain, userEmail } = window.GadgetInfo;
    if (code === "404") {
        return /*#__PURE__*/ react.createElement(NotFound/* NotFound */.T, null);
    } else if (ggtCode && ggtCode === "GGT_UNDEPLOYED_ENVIRONMENT" && primaryDomain) {
        return /*#__PURE__*/ react.createElement(UndeployedEnvironment, {
            primaryDomain: primaryDomain
        });
    } else if (ggtCode && ggtCode === "GGT_STILL_SETTING_UP" && primaryDomain) {
        return /*#__PURE__*/ react.createElement(StillSettingUp, {
            primaryDomain: primaryDomain
        });
    } else if (code === "403") {
        return /*#__PURE__*/ react.createElement(chrome_NoPermission, {
            userEmail: userEmail,
            message: message
        });
    } else if (code === "402" || code === "423") {
        return /*#__PURE__*/ react.createElement(ApplicationUnavailable, {
            code: code,
            userEmail: userEmail
        });
    } else {
        return /*#__PURE__*/ react.createElement(InfoPage, {
            icon: icon,
            message: message,
            poll: poll,
            logsLink: logsLink,
            userEmail: userEmail
        });
    }
};
const InfoApp = ()=>/*#__PURE__*/ react.createElement(flags/* FlagsProvider */.Q_, {
        flags: flags/* CurrentFlags */.p
    }, /*#__PURE__*/ react.createElement(browser_es5_es/* Provider */.zt, {
        value: styletronEngine/* styletronEngine */.F,
        debug: styletronEngine/* styletronDebug */.A
    }, /*#__PURE__*/ react.createElement(base_provider/* default */.Z, {
        theme: EditTheme/* EditLightTheme */.PW,
        overrides: {
            AppContainer: {
                style: {
                    height: "100%"
                }
            }
        }
    }, /*#__PURE__*/ react.createElement(InfoAppContainer, null))));

;// CONCATENATED MODULE: ./src/info.tsx







if (true) {
    sdk/* init */.S({
        dsn: "https://d043e398111b4b64bb3ba9038b2b3555@o250689.ingest.sentry.io/5352810"
    });
}
installErrorHandler();
react_dom.unstable_createRoot((0,utils/* assert */.hu)(document.getElementById("root"))).render(/*#__PURE__*/ react.createElement(react.StrictMode, null, /*#__PURE__*/ react.createElement(InfoApp, null)));


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [8834,284,4441,5757,2435,1327,2228,5221,5507], () => (__webpack_exec__(45695)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);